import React, { useCallback, useEffect } from 'react';
import { callEventPlan, getPlan } from '../../../../../contexts/PlanOperationContext/Plan';
import { AVAILABLE_TIME_TYPE } from '../../../../../util/varibles/constants';
import { addClassName, clearSelect, removeClassName } from '../../../../../util/varibles/global';
import { IVessel } from '../../../../../util/varibles/interface';
import { CALENDAR_ID } from '../../../constants';
import { EL_RULE } from '../../Calendar/constants';
import styles from '../style.module.scss';

let pageX = 0, pageY = 0, scrollLeft = 0, scrollTop = 0;

interface IProps {
    time: number
    vessel: IVessel
}

const Day: React.FC<IProps> = ({ time, vessel }) => {
    const { setTarget } = callEventPlan();
    const get = getPlan();
    const { isOwn, permission: vesselPermission, available_time_type } = vessel;
    const isAccessFull = !!(isOwn || vesselPermission || available_time_type === AVAILABLE_TIME_TYPE.ALL);

    const handleMouseMove = useCallback((e: any) => {
        const el = document.getElementById(CALENDAR_ID);
        if (el) {
            el.scrollLeft = scrollLeft - e.pageX + pageX;
            el.scrollTop = scrollTop - e.pageY + pageY;
        }
    }, []);

    const handleMouseUp = useCallback(() => {
        removeClassName(document.body);
        clearSelect();
        const el = document.getElementById(CALENDAR_ID);
        if (el) {
            delete el.dataset.dragging;
        }
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    }, [handleMouseMove])

    useEffect(() => {
        return handleMouseUp;
    }, [handleMouseUp]);

    const handleMouseDown = useCallback((e: any) => {
        const { permission } = get();
        if (permission.OP_MENU)
            setTarget({ type: EL_RULE.VESSEL, vessel, time }, e)

        if (e.button !== 0)
            return;
        pageX = e.pageX;
        pageY = e.pageY;
        const el = document.getElementById(CALENDAR_ID);
        if (el) {
            el.dataset.dragging = "true";
            scrollLeft = el.scrollLeft;
            scrollTop = el.scrollTop;
        }
        addClassName(document.body);
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    }, [get, handleMouseMove, handleMouseUp, setTarget, time, vessel]);


    return <div
        className={styles.day}
        data-date={time}
        data-vessel-id={vessel.id}
        data-access-full={isAccessFull}
        onMouseDown={handleMouseDown}
    />
};

export default Day;
